import userPlans from '@/hooks/userPlans';
import { apiCaller } from '@/redux/query';
import { isSkipApiSelector } from '@/redux/slice/auth.slice';
import { previewBackupSelector } from '@/redux/slice/preview.slice';
import { useSelector } from 'react-redux';

const UseLimitPlan = () => {
  const { isUserFreeOrBasicLimited, isUserBasicLimited } = userPlans();

  const isSkip = useSelector(isSkipApiSelector);
  const { status: statusBackup, id } = useSelector(previewBackupSelector) ?? {};

  const { data, isFetching } = apiCaller.useGetTotalRuleActiveQuery(undefined, { skip: isSkip });

  const numberRulePopupActive = Number(data?.ruleCount?.popup) || 0;
  const numberRuleTranslation = data?.ruleCount?.translation || 0;

  const isLimitOneRulePopup = numberRulePopupActive >= 1 && isUserFreeOrBasicLimited;
  const shouldShowWhenUpdateRulePopupDisabled = isLimitOneRulePopup && !statusBackup && Boolean(id) && !isFetching;

  const shouldShowWhenCreateNewRulePopup = isLimitOneRulePopup && !id && !isFetching;
  const isShowUpgradeNowRulePopup = shouldShowWhenUpdateRulePopupDisabled || shouldShowWhenCreateNewRulePopup; // Đối với Free và Basic thì chỉ được enable 1 rule popup

  const isLimitOneRuleTranslation = numberRuleTranslation >= 1 && isUserBasicLimited;

  return {
    numberRulePopupActive,
    numberRuleTranslation,
    isLimitOneRulePopup,
    isShowUpgradeNowRulePopup,
    isLimitOneRuleTranslation,
  };
};

export default UseLimitPlan;
